/* PawDent — reveal-on-scroll משותף לכל הסקשנים (.pd-reveal).
   התוכן גלוי כברירת מחדל; מוסתר לצורך אנימציה רק אם הוא מתחת לקו המסך. */
(function () {
  if (window.__pdRevealInit) return;
  window.__pdRevealInit = true;

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.remove('pd-hidden');
          e.target.classList.add('pd-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  }

  function reveal() {
    // מסתירים (לצורך אנימציה) רק אלמנטים שעדיין מתחת לקו המסך — לעולם לא תוכן שכבר נראה
    var els = document.querySelectorAll('.pd-reveal:not(.pd-in):not(.pd-hidden)');
    els.forEach(function (e) {
      if (!io) { e.classList.add('pd-in'); return; }
      var top = e.getBoundingClientRect().top;
      if (top > window.innerHeight * 0.9) {
        e.classList.add('pd-hidden');
        io.observe(e);
      } else {
        e.classList.add('pd-in');
      }
    });
  }

  if (document.readyState !== 'loading') reveal();
  else document.addEventListener('DOMContentLoaded', reveal);

  // Theme Editor: סקשן שמתרנדר מחדש חוזר בלי pd-in — מריצים שוב כדי שלא ייעלם
  document.addEventListener('shopify:section:load', reveal);
})();
